<template>
  <div class="waf-component waf-fantasy-contests main-fantasy-contests" v-if="showInLHS">
    <div class="layout-wrapper">
      <div class="waf-head">
        <h3 class="widget-title">{{ titleTxt() }}</h3>
      </div>
      <div class="waf-body" v-if="contest_loaded">
        <div class="contest-list" v-if="contests_list && contests_list.length">
          <a
            :class="['contest-item img-1by1', {'disabled': current_match.status !== 1}]"
            v-for="(contest_details, idx) in contests_list"
            v-bind:key="idx"
            v-bind:href="getRedirectURL(contest_details)"
            target="_blank"
            @click="onContestClick($event)"
            rel="nofollow"
          >
            <div class="contest-thumbnail">
              <div class="img-box">
                <img
                  :src="getImageUrl(contest_details)"
                  :alt="contest_details.cid"
                  class="loading"
                />
              </div>
            </div>
            <div class="contest-info">
              <div class="info-wrap">
                <div class="info-section1">
                  <div class="info-section-wrap">
                    <div class="name">
                      {{ translations.currency_symbol }}
                      {{ convert_number(contest_details.tp) }}
                    </div>
                    <div class="price-detail">
                      <span class="entry-fee"
                        >{{ translations.entry }}
                        {{ translations.currency_symbol }}
                        {{ convert_number(contest_details.ef) }}</span
                      >
                      <span class="spot"
                        >{{ translations.spots }}:
                        {{
                          Number(contest_details.pc).toLocaleString("en-IN")
                        }}</span
                      >
                    </div>
                  </div>
                  <div class="contest-rating">
                    <span class="profit">{{
                      translations.approx_winnings
                    }}</span>
                    <span
                      :class="[
                        'rating',
                        contest_details.ar < 0
                          ? 'loss'
                          : contest_details.ar !== 0
                          ? 'success'
                          : '',
                      ]"
                      >{{ translations.currency_symbol }}
                      {{ convert_number(contest_details.mp) }}</span
                    >
                  </div>
                </div>
                <div class="info-section2">
                  <span class="prize-pool"
                    >{{ translations.top_prize }}:
                    {{ translations.currency_symbol }}
                    {{ convert_number(contest_details.hp) }}</span
                  >
                  <span class="winning">
                    {{
                      getParticipantBracket(
                        contest_details,
                        translations.contestType
                      )
                    }}
                  </span>
                </div>
              </div>
            </div>
          </a>
        </div>
        <div class="contest-list" v-else>
          <div class="no-data">
            <p class="msg">{{ translations.noContestsFound }}</p>
          </div>
        </div>
        <div class="btn-wrap" v-if="contests_list && contests_list.length">
          <a class="btn btn-link" :href="getViewAllLink()" target="_blank"><span>{{translations.viewAll}}</span>({{contest_count}})</a>
        </div>
        <p class="disclaimer-txt" v-if="contests_list && contests_list.length">{{translations.contestDisclaimer}}</p>
      </div>
      <div class="waf-body" v-else>
        <div class="contest-list">
          <a
            class="contest-item img-1by1"
            v-for="c in [1,2,3]"
            v-bind:key="c"
            rel="nofollow"
          >
            <div class="contest-thumbnail shimmer">
              <div class="img-box"></div>
            </div>
            <div class="contest-info shimmer">
              <div class="info-wrap"></div>
            </div>
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {
  CFG_WIDGET_URL_BASE,
  CFG_PLATFORM_IMAGE_DOMAIN,
  CFG_CUSTOM_CONTEST_REDIRECTS,
  CFG_CONTEST_PARTICIPANT_BRACKETS,
  CFG_MODULES,
} from "../../assets/js/config";
import { convertNumber, formatFullUrl } from "../../assets/js/common";
export default {
  props: ["current_match", "showInLHS", "storeName"],
  computed: {
    translations() {
      return this.$store.state.translations;
    },
    is_pre_match() {
      let curr_match = this.current_match;
      return !!(curr_match && curr_match.status === 1);
    },
    contest_loaded() {
      return this.$store.state[this.storeName].contest_loaded;
    },
    contests_list() {
      if(this.$store.state && this.$store.state[this.storeName]){
        return this.$store.state[this.storeName].selectedMatchContests;
      } else {
        return [];
      }
    },
    contest_count() {
      if(this.$store.state && this.$store.state[this.storeName]) {
        return this.$store.state[this.storeName].contest_count;
      } else {
        return 0;
      }
    },
  },
  methods: {
    titleTxt() {
      let trans = this.translations;
      let text = trans.contestWidgetTitle;
      let vsTxt = "";
      if (
        this.current_match &&
        this.current_match.teams &&
        this.current_match.teams.length
      ) {
        vsTxt = `${this.current_match.teams[0].short_name} ${trans.vs_label} ${this.current_match.teams[1].short_name}`;
      }
      return text.replace("{{teams}}", vsTxt);
    },
    getParticipantBracket(contest_details, outputText) {
      let bracket = CFG_CONTEST_PARTICIPANT_BRACKETS.find(
        (cp) => contest_details.pc >= cp.min && contest_details.pc <= cp.max
      );
      let bracketVal =
        bracket && bracket.contestType ? bracket.contestType : "-";
      return outputText.replace("{{type}}", bracketVal);
    },
    getRedirectURL(contest_details) {
      if (CFG_CUSTOM_CONTEST_REDIRECTS[contest_details.pid]) {
        return CFG_CUSTOM_CONTEST_REDIRECTS[contest_details.pid].redirect_url;
      }
      return contest_details.cu !== "" && this.addUtmParams(contest_details.cu);
    },
    addUtmParams: function (cu) {
      if (!cu) return cu;
      let url = new URL(cu);
      let utm_Params = {
        utm_source: "ndtv_fg",
        utm_medium: "website"
      };
      Object.keys(utm_Params).forEach((key) => {
        url.searchParams.set(key, utm_Params[key]);
      });
      return url;
    },
    onContestClick: function (event) {
      //condition added if current match is expired one
      if (this.current_match.status !== 1) {
        event.stopPropagation();
        event.preventDefault();
        return false;
      }
    },
    convert_number: function (val) {
      return convertNumber(val);
    },
    getImageUrl: function (contest_details) {
      return (
        CFG_WIDGET_URL_BASE + CFG_PLATFORM_IMAGE_DOMAIN + contest_details.pi
      );
    },
    getViewAllLink: function () {
      let match = this.current_match;
      if (typeof match !== "undefined") {
        let route = CFG_MODULES.GAME_PLAN.route;
        let matchUrl = formatFullUrl(match, route);
        return (CFG_WIDGET_URL_BASE + matchUrl + '?utm_source=ndtv&utm_medium=website');
      } else {
        return null;
      }
    },
    setContestInRHS() {
      let contestListElem = document.querySelector("#FG_CONTEST_RHS .waf-body");
      if(contestListElem) {
        let translations = this.translations;
        let allowContestClick = (this.current_match.status === 1);
        let list = this.contests_list;
        let lt = '', cta_wrap = '';
        if(list && list.length){
          for(let c=0; c<list.length; c++){
            let contest_details = list[c];
            let contestLink = this.getRedirectURL(contest_details);
            let contestImg = this.getImageUrl(contest_details);
            let cHref = allowContestClick ? `href="${contestLink}"` : ``; // allow contest click to preMatch
            let cDisabled = !allowContestClick ? " disabled" : "";
            lt += `<a ${cHref} target="_blank" rel="nofollow" class="contest-item img-1by1${cDisabled}">
                  <div class="contest-thumbnail">
                      <div class="img-box">
                          <img src="${contestImg}" alt="${contest_details.cid}" class="loading" />
                      </div>
                  </div>
                  <div class="contest-info">
                      <div class="info-wrap">
                          <div class="info-section1">
                              <div class="info-section-wrap">
                                  <div class="name"> ${translations.currency_symbol}${this.convert_number(contest_details.tp)} </div>
                                  <div class="price-detail"><span class="entry-fee">${translations.entry} ${translations.currency_symbol} ${this.convert_number(contest_details.ef)}</span>
                                      <span class="spot">${translations.spots}: ${Number(contest_details.pc).toLocaleString("en-IN")}</span>
                                  </div>
                              </div>
                              <div class="contest-rating"><span class="profit">${translations.approx_winnings}</span> <span class="rating${contest_details.ar < 0 ? ' loss' : contest_details.ar !== 0 ? ' success' : ''}">${translations.currency_symbol}${this.convert_number(contest_details.mp)}</span></div>
                          </div>
                          <div class="info-section2"><span class="prize-pool">${translations.top_prize}: ${translations.currency_symbol}${this.convert_number(contest_details.hp)}</span> <span class="winning"> ${this.getParticipantBracket(contest_details, translations.contestType)} </span></div>
                      </div>
                  </div>
              </a>`;
          }
          let viewAllLink = this.getViewAllLink();
          if(viewAllLink){
            cta_wrap += `<div class="btn-wrap">
              <a class="btn btn-link" href="${viewAllLink}" target="_blank"><span>${translations.viewAll}</span>(${this.contest_count})</a>
            </div><p class="disclaimer-txt">${translations.contestDisclaimer}</p>`;
          }
        } else {
          lt = `<div class="no-data">
            <p class="msg">${translations.noContestsFound}</p>
          </div>`;
        }
      
        contestListElem.innerHTML = `<div class="contest-list">${lt}</div>${cta_wrap}`;
      }
    },
  },
  watch: {
    contest_loaded(newVal, oldVal) {
      if(oldVal !== newVal){
        this.setContestInRHS();
      }
    },
    contests_list(newList, oldList) {
      let changeDetected = (oldList.length !== newList.length); // compare lengths
      if(!changeDetected){
        // if lengths are same then check ids.
        const oldIds = oldList.reduce((oldIdArr, c) => {
          oldIdArr.push(c.cid); return oldIdArr;
        }, []);
        const newIds = newList.reduce((newIdArr, c) => {
          newIdArr.push(c.cid); return newIdArr;
        }, []);
        let difference = newIds.filter(x => !oldIds.includes(x));
        if(difference.length){
          changeDetected = true; // when cid in old and new are different
        }
      }

      if (changeDetected) {
        this.setContestInRHS();
      }
    }
  },
  beforeDestroy() {
    clearTimeout(this.timeOut);
  },
};
</script>
